import { ResponseGetAuthUser } from "@CommonApi/auth/user";
import { useEffect } from "react";
import { useUser } from "src/atoms/user";
import { clearLocalStorage, pages } from "src/utils";
import { deleteRedirectUrl } from "src/utils/sessionStorage";

export const PageLogout = () => {
  const { setUser } = useUser();

  useEffect(() => {
    setUser(null as unknown as ResponseGetAuthUser);
    deleteRedirectUrl();
    clearLocalStorage();
    window.location.href = pages.login;
  }, []);

  return null;
};
